import type { CommonResponseTeacherSettingDto } from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import { type TeacherSetting, TeacherSettingSchema } from './schemas'

// 생성 타입은 검색·빠른 메뉴·연구소 설정과 그 안의 값을 optional(키 생략)로 그리지만 서버는 키를 빼지 않고 null 을
// 싣는다. 2026-10-14 백엔드 develop(6a0f8e7bb) 의 teacher/model/dto/TeacherSettingDto.kt 선언과 팀이 녹음한 dev 응답
// e2e 목(teachers-setting.ts)으로 확인. 스키마가 실제 와이어를 검증하므로 입력을 이 한 자리에서 unknown 으로 넘긴다.
const asWire = (raw: CommonResponseTeacherSettingDto['data']): unknown => raw

export const adaptTeacherSetting = (raw: CommonResponseTeacherSettingDto['data']): TeacherSetting =>
  parseApiResponse(TeacherSettingSchema, asWire(raw), 'TeacherSetting')
